<div class="banner">
  <div class="logo-container">
    <img [src]="orgConfigService.getOrganizationConfig().logo_image"
         *ngIf="orgConfigService.getOrganizationConfig() && orgConfigService.getOrganizationConfig().logo_image">
  </div>
</div>

<div class="row mt-4">
  <div class="col-md-4 pr-md-2">
    <div class="card">
      <div class="card-body">
        <p class="card-metric">
          <span [class.text-danger]="locationIsOverCapacity()">{{ (loadingCheckInStats || !checkInStats) ? '--' : checkInStats.currently_checked_in_count }}</span>/{{ (loadingLocation || !location) ? '--' : location.capacity }}
        </p>
        <p class="card-label">Current Capacity</p>
      </div>
    </div>
  </div>
  <div class="col-md-4 px-md-2">
    <div class="card">
      <div class="card-body">
        <p class="card-metric">
          {{ (loadingCheckInStats || !checkInStats) ? '--' : checkInStats.check_ins_today_count }}
        </p>
        <p class="card-label">Daily Check-Ins</p>
      </div>
    </div>
  </div>
  <div class="col-md-4 pl-md-2">
    <div class="card">
      <div class="card-body">
        <p class="card-metric"
           *ngIf="inboxService.getInboxCounts()">
          {{ inboxService.getInboxCounts().inbox_total }}
        </p>
        <p class="card-metric"
           *ngIf="!inboxService.getInboxCounts()">
          -
        </p>
        <p class="card-label">Inbox Items</p>
      </div>
    </div>
  </div>
</div>

<div class="row mt-4 mb-5">
  <div class="col-md-4 pr-md-2">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title" *ngIf="loadingScheduledEvents">Loading Today's Events...</h5>

        <ng-container *ngIf="!loadingScheduledEvents">
          <h5 class="card-title">Today's Events</h5>

          <ng-container *ngIf="locationService.getLocations() && locationService.getLocations().length > 1">
            <select class="custom-select custom-select-sm"
                    [(ngModel)]="todaysEventsLocationId"
                    (ngModelChange)="loadScheduledEvents()">
              <option [ngValue]="undefined">at all Locations</option>
              <option *ngFor="let location of locationService.getLocations()"
                      [ngValue]="location.id">
                at {{ location.name }}
              </option>
            </select>
          </ng-container>

          <div class="card my-3"
               *ngIf="!scheduledEventsPresent()">
            <p class="text-center my-4">No Events Today</p>
          </div>

          <div class="card mt-2" *ngFor="let scheduledEvent of scheduledEventsList"
               [routerLink]="myAccount.can_manage_events ? getEventLink(scheduledEvent) : '#'"
               [class.event-ended]="scheduledEvent.has_ended"
               [class.event-in-progress]="!scheduledEvent.has_ended && scheduledEvent.has_started"
               [class.event-in-future]="!scheduledEvent.has_ended && !scheduledEvent.has_started">
            <div class="card-body p-3">
              <p class="note-body mb-0">
                {{ timeStringFromISO8601(scheduledEvent.start_datetime, scheduledEvent.time_zone) }} -
                {{ timeStringFromISO8601(scheduledEvent.end_datetime, scheduledEvent.time_zone) }}
                <br>
                <b>{{ scheduledEvent.name }}</b>
                <ng-container *ngIf="todaysEventsLocationId === undefined">
                  <br>
                  {{ scheduledEvent.location_name }}
                </ng-container>
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="col-md-8 pl-md-2">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title" *ngIf="loadingStaffNotes">Loading Team Notes...</h5>

        <ng-container *ngIf="!loadingStaffNotes">
          <button class="btn btn-outline-primary btn-sm float-right"
                  (click)="openAddNoteModal()">
            Add Note
          </button>
          <h5 class="card-title">Team Notes</h5>

          <div class="card mt-3"
               *ngIf="!staffNotesPresent()">
            <p class="text-center my-4">No Team Notes</p>
          </div>

          <div class="card mt-3"
               *ngFor="let staffNote of staffNotesList.results">
            <div class="card-body">
              <button class="btn btn-outline-primary btn-sm float-right ml-2"
                      (click)="dismissNote(staffNote)">
                Dismiss
              </button>
              <button class="btn btn-outline-primary btn-sm float-right"
                      (click)="openEditNoteModal(staffNote)">
                Edit
              </button>

              <p class="note-header">
                {{ dateStringFromISO8601(staffNote.created_at) }}<br>
                {{ staffNote.created_by_first_name }} {{ staffNote.created_by_last_name }}
              </p>

              <p class="note-body mb-0">
                {{ staffNote.text }}
              </p>
            </div>
          </div>

          <button class="btn btn-link dismissed-btn d-block mx-auto mt-4 disabled"
                  disabled
                  *ngIf="loadingDismissedNotes">
            LOADING DISMISSED NOTES...
          </button>

          <ng-container *ngIf="!loadingDismissedNotes">
            <button class="btn btn-link dismissed-btn d-block mx-auto mt-4 cursor-default"
                    *ngIf="!dismissedNotesPresent()">
              NO DISMISSED NOTES
            </button>

            <button class="btn btn-link dismissed-btn d-block mx-auto mt-4"
                    *ngIf="dismissedNotesPresent() && !showDismissedNotes"
                    (click)="showDismissedNotes = true">
              VIEW DISMISSED NOTES
            </button>

            <button class="btn btn-link dismissed-btn d-block mx-auto mt-4"
                    *ngIf="dismissedNotesPresent() && showDismissedNotes"
                    (click)="showDismissedNotes = false">
              HIDE DISMISSED NOTES
            </button>

            <ng-container *ngIf="showDismissedNotes">
              <div class="card mt-3"
                   *ngFor="let dismissedNote of dismissedNotesList.results">
                <div class="card-body">
                  <button class="btn btn-outline-primary btn-sm float-right"
                          (click)="undoDismissNote(dismissedNote)">
                    Undo Dismiss
                  </button>

                  <p class="note-header">
                    {{ dateStringFromISO8601(dismissedNote.created_at) }}<br>
                    {{ dismissedNote.created_by_first_name }} {{ dismissedNote.created_by_last_name }}
                  </p>

                  <p class="note-body mb-0">
                    {{ dismissedNote.text }}
                  </p>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
